import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './contact-accordion-single.component.scss';
var ContactAccordionSingle = /** @class */ (function (_super) {
    tslib_1.__extends(ContactAccordionSingle, _super);
    function ContactAccordionSingle(element) {
        return _super.call(this, element) || this;
    }
    ContactAccordionSingle.prototype.init = function () { };
    ContactAccordionSingle.prototype.bindEvents = function () { };
    return ContactAccordionSingle;
}(Base));
export { ContactAccordionSingle };



//////////////////
// WEBPACK FOOTER
// ./components/contact-accordion-single/contact-accordion-single.component.ts
// module id = 205
// module chunks = 0